import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/requestedlevel.scss';

/** RequestedLevel Component
 *
 * This is meant as an extension to the Intellectual Capabilities report widget and simply shows the given indication
 * text in a bottom-rounded element.
 *
 * @example
 * <RequestedLevel
 *     text={ 'This person has the requested level' }
 * />
 */
export default class RequestedLevel extends Component {
    render() {
        const { text } = this.props;

        return <section className={ style.requestedLevel }>
            <p dangerouslySetInnerHTML={{ __html: text }} />
        </section>;
    }
}

RequestedLevel.propTypes = {
    text: PropTypes.string
};

RequestedLevel.defaultProps = {
    text: null
};
